import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router'
import { message } from 'services/snackbar'
import { currentUserSelector } from 'services/users/selectors'

const SNACK_TIMEOUT = 3000

export function AdminLogin() {
  const dispatch = useDispatch()
  const location = useLocation()
  const user = useSelector(currentUserSelector)

  React.useEffect(() => {
    if (!user) {
      dispatch(message('Please log in to the app first.', 'info', SNACK_TIMEOUT, true))
    } else if (!user.roles?.isAdmin) {
      dispatch(message('You do not have permission to access this page.', 'error', SNACK_TIMEOUT, true))
    }
  }, [dispatch, user])

  if (user?.roles?.isAdmin) {
    return <Navigate to="/admin/support/users" replace />
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return <Navigate to="/" replace />
}

export default AdminLogin
